import React, { useState, useEffect } from "react";
import AccessoriesSectionCard from "../../components/common/Accessories-Section-Card/AccessoriesSectionCard";
import accessoriesproduct1 from "../../assets/img/accessoriesproduct1.png";
import "../../assets/css/product-details.css";
import ProductCarouselCard from "../../components/common/Product-Carousel-Card/Product-Carousel-Card";
// import ProductDescription from "../../components/common/Product-Description/Product-Description";

import { useSelector } from "react-redux";
import { checkSessionValidity, getSampleCurrencyFormat } from "../../utils/utils";
import {
  CATEGORY_BREADCRUMBS,
  PRODUCT_DETAILS,
  CATEGORY_PRODUCTS,
  CATEGORY_PRODUCTS_FILTER,
  RELATED_PRODUCT,
  PRODUCT_AVAILABLE_OPTIONS,
  PRODUCT_DETAILS_LINK,
  PRODUCT_ATTRIBUTES,
} from "../../assets/graphql";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useParams } from "react-router-dom";
import {
  saveproductDetails,
  savecategoryProduct,
  savegetrelatedproduct,
  saveProductDetailsLink,
  shareAttributes,
} from "../../features/HomePageSlice/homeDataSlice";
import { useDispatch } from "react-redux";
import RelatedProductCard from "../../components/common/RelatedProductCard/RelatedProductCard";
import Loader from "../../components/common/Loader/loader";
import ProductFilterCard from "../../components/common/Product-Filter-Card/ProductFilterCard";

const ProductDetail = () => {
  const [breadcrumbData, setBreadcrumbData] = useState({});
  const [filter, setFilter] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({});
  const [availableOptions, setAvailableOptions] = useState({});
  const [selectedFilterUid, setSelectedFilterUid] = useState({});
  const [step, setStep] = useState(0);
  const [option, setOption] = useState([]);
  const [selectedOptionUid, setSelectedOptionUid] = useState({});
  const [loader, setLoader] = useState(true);
  const [setClassNewName, classNewName] = useState("colorcode");

  const { id } = useParams();
  const { productDetails, getrelatedproduct } = useSelector((state) => state.home);

  // console.log(productDetails);
  const { token } = useSelector((state) => state.login);

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 750);
  }, []);

  const getProductDetail = async (id) => {
    // setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { sku: decodeURIComponent(id) },
        query: PRODUCT_DETAILS,
      },
    });
    checkSessionValidity(result.data, dispatch);
    // setLoader(false);

    if (!result.data.error_code) {
      dispatch(saveproductDetails(result.data.products.items));
    }
    updateFilterOption([]);
  };
  const getProductAttrbutes = async (id) => {
    // setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { sku: decodeURIComponent(id) },
        query: PRODUCT_ATTRIBUTES,
      },
    });
    // setLoader(false);

    if (!result.data.error_code) {
    
      dispatch(shareAttributes(result.data.productAttributes))
    }
  
  };
  const getProductDetailLink = async (id) => {
    // setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { sku: decodeURIComponent(id) },
        query: PRODUCT_DETAILS_LINK,
      },
    });
    
    // setLoader(false);

    if (!result.data.error_code) {
    
      dispatch(saveProductDetailsLink(result.data.attributeValues))
    }
  
  };
  const handleOptionChange = (option) => {
    setSelectedOptionUid({
      ...selectedOptionUid,
      [option.uid]: {
        status: !(selectedOptionUid[option.uid] && selectedOptionUid[option.uid].status),
        price: option.price,
      },
    });
  };
  const handleFilterChange = (attribute_code, filter, step, availableFilter) => {
    step = step + 1;
    setStep(step);
    if (attribute_code === "price") {
      let from = 0,
        to = 0;
      let index = filter.value.indexOf("_");
      from = filter.value.substr(0, index);
      to = filter.value.substr(index + 1, filter.value.length);

      let filterPrice = {
        from: from,
        to: to,
      };
      setSelectedFilter({ ...selectedFilter, price: filterPrice });
      // selectedCategoryProduct({ ...selectedFilter, price: filterPrice });
    } else if (attribute_code === "category_id") {
      setSelectedFilter({
        ...selectedFilter,
        category_id: { eq: filter.value },
      });
      // selectedCategoryProduct({
      //   ...selectedFilter,
      //   category_id: { eq: filter.value },
      // });
    } else if (attribute_code === "color") {
      
      const elements = document.querySelectorAll('.colorcode');
    elements.forEach((element) => {
      element.classList.remove('active');
    });
     
      const element = document.getElementById(filter);
      element.classList.toggle('active');
     
      setSelectedFilter({ ...selectedFilter, color: { eq: filter } });
      // selectedCategoryProduct({
      //   ...selectedFilter,
      //   color: { eq: filter },
      // });
    } else if (attribute_code === "size") {
      setSelectedFilter({ ...selectedFilter, size: { eq: filter } });
      // selectedCategoryProduct({
      //   ...selectedFilter,
      //   size: { eq: filter },
      // });
    } else {
      setSelectedFilter({ ...selectedFilter, [attribute_code]: filter });
      // selectedCategoryProduct({
      //   ...selectedFilter,
      //   [attribute_code]: filter.value,
      // });
    }

    setSelectedFilterUid({
      ...selectedFilterUid,
      [attribute_code]: { step: step, uid: filter },
    });
    // const selCode = [];
    // [...Array(step + 1)].forEach((n, i) => {
    //   const code = availableFilter[i].code;
    //   const uid = selectedFilterUid[code];
    //   if (uid && code !== attribute_code) selCode.push(uid);
    // });
    // selCode.push(filter.uid);
    
    updateFilterOption({
      ...selectedFilterUid,
      [attribute_code]: { step: step, uid: filter },
    });
    // updateFilterOption(selCode);
  };
  const updateFilterOption = async (filterUid) => {
    // console.log(filterUid, "filteroption");
    // setLoader(true);
    let sort_filter = Object.values(filterUid).sort((a, b) => {
      // console.log(a, b);
      return a.step - b.step;
    });
    // console.log("SORT - ", sort_filter);
    let uid_filter = sort_filter.map((u) => u.uid);
    // console.log("UIDS - ", uid_filter);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { sku: decodeURIComponent(id), optionValueUids: uid_filter },
        query: PRODUCT_AVAILABLE_OPTIONS,
      },
    });
    // console.log(result.data, "datat geett")
    checkSessionValidity(result.data, dispatch);
    // setLoader(false);

    if (result.data.message) {
      // console.log("MESSAGE  - ");
      setAvailableOptions(result.data.message.data);
    } else {
      // console.log("MESSAGE  - ", result.data);
      setAvailableOptions(result.data);
    }
  };
  const selectedCategoryProduct = async (filter) => {
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { filter: { ...filter } },
        query: CATEGORY_PRODUCTS_FILTER,
      },
    });
    if (!result.data.error_code) {
      setFilter(result.data.products.aggregations);
    }
  };

  const getRelatedProduct = async (id) => {
    // setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { sku: id },
        query: RELATED_PRODUCT,
      },
    });
    checkSessionValidity(result.data, dispatch);
    // setLoader(false);
    if (!result.data.error_code) {
      dispatch(savegetrelatedproduct(result.data.products.items));
    }
  };

  useEffect(() => {
    getProductDetail(id);
    getRelatedProduct(id);
    getProductDetailLink(id);
    getProductAttrbutes(id);
  }, [id]);
  useEffect(() => {
    if (productDetails && productDetails[0] && productDetails[0].id) {
      const { configurable_options } = productDetails[0];
      const filterOptions =
        configurable_options &&
        configurable_options.map((conf) => {
          const conf_options = conf.values.map((v) => {
            let colorCode = '1px solid rgb(205, 102, 108)';
            if(v.swatch_data) {
              colorCode = v.swatch_data.value === "#000000" ? "1px solid #ffffff" : v.swatch_data.value === "#ffffff" ? '1px solid #000000' : '1px solid rgb(205, 102, 108)'
            }
            return {
              label: v.label,
              uid: v.uid,
              value: v.swatch_data,
              styleBorder: colorCode
            };
          });
          return {
            attribute_code: conf.attribute_code,
            position: conf.position,
            label: conf.label,
            options: conf_options,
          };
        });
      setFilter(filterOptions);
    }
  }, [productDetails]);

  const getBreadCrumbData = () => {
    let list = [];
    if (productDetails && productDetails[0]) {
      const { categories } = productDetails && productDetails[0];

      if (categories) {
        let isAccessory = false;
        list.push({ name: "Home", url: "/home" });
        categories &&
          categories.forEach((cat, index) => {
            if (cat.display_subcategory === 1) {
              list.push({
                name: cat.name,
                url: "/category-list/" + cat.url_key,
                url_path: cat.url_path,
              });
              isAccessory = true;
            } else {
              if (index !== categories.length - 1 || isAccessory)
                list.push({
                  name: cat.name,
                  url: "/product-list/" + cat.url_key,
                  url_path: cat.url_path,
                });
            }
          });
        list.push({ name: productDetails[0].name, url: "" });
      }
    }
    return list;
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="product-custom-filter">
            <section className="custombreadcrumb">
              <Breadcrumb data={getBreadCrumbData()} />
            </section>
            <section className="pt-5 pb-5">
              <div className="container">
                <div className="row">
                  <div className="col-lg-4 col-md-5 col-xs-12 pt-3 order-2 order-md-1">
                    <div className="customfilter d-none d-md-block d-lg-block product-custom-filter">
                      <h4 className="d-flex align-items-center">
                        <img
                          src="data:image/png;base64,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"
                          className="pe-2"
                        />
                        Variant
                      </h4>
                      <div className="accordion pt-2 pe-5" id="accordionExample">
                        {filter.map((value) => (
                          <div className="accordion-item">
                            <h2 className="accordion-header" id="headingsize">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOnesize"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                              >
                                {value.label} <span className="tempLabel" />
                              </button>
                            </h2>
                            <div
                              id="collapseOnesize"
                              className="accordion-collapse"
                              aria-labelledby="headingsize"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                {["color"].includes(value.attribute_code) ? (
                                  <>
                                  {value.options.map((colorCode, index) => (
                                    //console.log(colorCode);
                                    <div className="address_row_name colorcodestyle">
                                      <input
                                        className="form-radio"
                                        type="radio"
                                        id={[colorCode.label, index]}
                                        name="color"
                                        onClick={() => handleFilterChange(value.attribute_code, colorCode.uid, step)}
                                      />
                                      <label htmlFor={[colorCode.label, index]}></label>
                                      <span className="name">{colorCode.label}</span>
                                      <div
                                        className="colorcode"
                                        id={[colorCode.uid]}
                                        style={{
                                          backgroundColor: colorCode?.value?.value,
                                          border: colorCode.styleBorder,
                                        }}
                                      ></div>
                                    </div>
                                  ))}
                                </>
                                ) : (
                                  <div className="address_row_name">
                                    {value.options.map((optionValue, index) => (
                                      <>
                                        <input
                                          className="form-radio"
                                          type="radio"
                                          name={value.attribute_code}
                                          onClick={() => handleFilterChange(value.attribute_code, optionValue.uid, step)}
                                        />
                                        <label />
                                        <span className="name"> {optionValue.label}</span>
                                        <br />
                                      </>
                                    ))}
                                  </div>
                                  
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="customfilter d-md-none d-lg-none product-custom-filter">
                      <div className="accordion pt-2 pe-5" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header customMobile" id="headingZero">
                            <button className="accordion-button" type="button">
                              <h4 className="d-flex align-items-center">
                                <img src="" className="pe-2" /> Variants
                              </h4>
                            </button>
                          </h2>
                          <div  id="collapseZero" className="accordion-collapse">
                            <div className="accordion-body">
                              {filter.map((value) => (
                                <div className="accordion-item">
                                  <h2 className="accordion-header" id="headingsize">
                                    <button
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseOnesize"
                                      aria-expanded="false"
                                      aria-controls="collapseOne"
                                    >
                                      {value.label} <span className="tempLabel" />
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseOnesize"
                                    className="accordion-collapse"
                                    aria-labelledby="headingsize"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      {["color"].includes(value.attribute_code) ? (
                                       <>
                                        {value.options.map((colorCode, index) => (
                                          //console.log(colorCode);
                                          <div className="address_row_name colorcodestyle">
                                            <input
                                              className="form-radio"
                                              type="radio"
                                              id={[colorCode.label, index]}
                                              name="color"
                                              onClick={() => handleFilterChange(value.attribute_code, colorCode.uid, step)}
                                            />
                                            <label htmlFor={[colorCode.label, index]}></label>
                                            <span className="name">{colorCode.label}</span>
                                            <div
                                              className="colorcode"
                                              id={[colorCode.uid]}
                                              style={{
                                                backgroundColor: colorCode?.value?.value,
                                                border: colorCode.styleBorder,
                                              }}
                                            ></div>
                                          </div>
                                        ))}
                                      </>
                                      ) : (
                                        <div className="address_row_name">
                                        {value.options.map((optionValue, index) => (
                                          <>
                                            <input
                                              className="form-radio"
                                              type="radio"
                                              name={value.attribute_code}
                                              onClick={() => handleFilterChange(value.attribute_code, optionValue.uid, step)}
                                            />
                                            <label />
                                            <span className="name"> {optionValue.label}</span>
                                            <br />
                                          </>
                                        ))}
                                      </div>
                                        
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                          {/* <div id="collapseZero" className="accordion-collapse">
                            <div className="accordion-body">
                              <div className="accordion-item">
                                <h2 className="accordion-header" id="headingsize">
                                  <button className="accordion-button" type="button">
                                    Display Size1
                                    <span className="tempLabel" />
                                  </button>
                                </h2>
                                <div id="collapseOnesize" className="accordion-collapse">
                                  <div className="accordion-body">
                                    <div className="address_row_name">
                                      <input className="form-radio" type="radio" name="size" />
                                      <label />
                                      <span className="name"> 6.1-inch</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="accordion-item">
                                <h2 className="accordion-header" id="headingcolor">
                                  <button className="accordion-button" disabled type="button">
                                    Color
                                    <span className="tempLabel" />
                                  </button>
                                </h2>
                                <div id="collapseOnecolor" className="accordion-collapse">
                                  <div className="accordion-body">
                                    <div className="address_row_name colorcodestyle">
                                      <input className="form-radio" type="radio" id="[object Object]" name="color" />
                                      <label htmlFor="[object Object]" />
                                      <span className="name"> Blue</span>
                                      <div
                                        className="colorcode"
                                        style={{
                                          backgroundColor: "rgb(144, 184, 197)",
                                          border: "1px solid rgb(205, 102, 108)",
                                        }}
                                      ></div>
                                    </div>
                                    <div className="address_row_name colorcodestyle">
                                      <input className="form-radio" type="radio" id="[object Object]" name="color" />
                                      <label htmlFor="[object Object]" />
                                      <span className="name"> Red</span>
                                      <div
                                        className="colorcode"
                                        style={{
                                          backgroundColor: "rgb(212, 26, 54)",
                                          border: "1px solid rgb(205, 102, 108)",
                                        }}
                                      ></div>
                                    </div>
                                    <div className="address_row_name colorcodestyle">
                                      <input className="form-radio" type="radio" id="[object Object]" name="color" />
                                      <label htmlFor="[object Object]" />
                                      <span className="name"> Purple</span>
                                      <div
                                        className="colorcode"
                                        style={{
                                          backgroundColor: "rgb(229, 222, 233)",
                                          border: "1px solid rgb(205, 102, 108)",
                                        }}
                                      ></div>
                                    </div>
                                    <div className="address_row_name colorcodestyle">
                                      <input className="form-radio" type="radio" id="[object Object]" name="color" />
                                      <label htmlFor="[object Object]" />
                                      <span className="name"> Starlight</span>
                                      <div
                                        className="colorcode"
                                        style={{
                                          backgroundColor: "rgb(252, 247, 244)",
                                          border: "1px solid rgb(205, 102, 108)",
                                        }}
                                      ></div>
                                    </div>
                                    <div className="address_row_name colorcodestyle">
                                      <input className="form-radio" type="radio" id="[object Object]" name="color" />
                                      <label htmlFor="[object Object]" />
                                      <span className="name"> Midnight</span>
                                      <div
                                        className="colorcode"
                                        style={{
                                          backgroundColor: "rgb(65, 71, 77)",
                                          border: "1px solid rgb(205, 102, 108)",
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="accordion-item">
                                <h2 className="accordion-header" id="headingstorage">
                                  <button className="accordion-button" disabled type="button">
                                    Storage
                                    <span className="tempLabel" />
                                  </button>
                                </h2>
                                <div id="collapseOnestorage" className="accordion-collapse">
                                  <div className="accordion-body">
                                    <div className="address_row_name">
                                      <input className="form-radio" type="radio" name="storage" />
                                      <label />
                                      <span className="name"> 128 GB</span>
                                    </div>
                                    <div className="address_row_name">
                                      <input className="form-radio" type="radio" name="storage" />
                                      <label />
                                      <span className="name"> 256 GB</span>
                                    </div>
                                    <div className="address_row_name">
                                      <input className="form-radio" type="radio" name="storage" />
                                      <label />
                                      <span className="name"> 512 GB</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-8 col-md-7 col-xs-12 price pt-3 order-1 order-md-2">
                    <ProductCarouselCard
                      ids={
                        productDetails &&
                        productDetails[0] &&
                        productDetails[0].variants &&
                        productDetails[0].variants[0] &&
                        productDetails[0].variants[0].product &&
                        productDetails[0].variants[0].product.id
                          ? productDetails &&
                            productDetails[0] &&
                            productDetails[0].variants &&
                            productDetails[0].variants[0] &&
                            productDetails[0].variants[0].product &&
                            productDetails[0].variants[0].product.id
                          : ""
                      }
                      availableOptions={availableOptions}
                      filterData={filter}
                      selectedFilterUid={selectedFilterUid}
                      selectedOptionUid={selectedOptionUid}
                      step={step}
                    />
                  </div>
                </div>
              </div>
           
            </section>
            <section className="pt-5 pb-5">
              <div className="container">
                <div className="row">
                  <div className="col-xl-8 mx-auto text-center mb-5">
                    <div className="mainsection-title">
                      {productDetails[0] &&
                      productDetails[0].related_products[0] &&
                      productDetails[0].related_products[0].name ? (
                        <h2>Related Products</h2>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row ">
                  {productDetails &&
                    productDetails[0] &&
                    productDetails[0].related_products &&
                    productDetails[0].related_products.map((item, index) => (
                      <div className="col-md-4" style={{ marginBottom: "20px" }} key={index}>
                        <RelatedProductCard
                          skuid={item.sku}
                          PrductImg={item.image.url}
                          ProductDetail={item.name}
                          // filterData={filter} selectedFilterUid={selectedFilterUid} step={step}
                          ProductPrice={getSampleCurrencyFormat(
                            item.price_range.minimum_price &&
                              item.price_range.minimum_price.final_price &&
                              item.price_range.minimum_price.final_price.currency
                              ? item.price_range.minimum_price.final_price.currency
                              : "INR",
                            item.price_range.minimum_price &&
                              item.price_range.minimum_price.final_price &&
                              item.price_range.minimum_price.final_price.value
                              ? item.price_range.minimum_price.final_price.value
                              : 0
                          )}
                        />
                      </div>
                    ))}
                </div>
              </div>
            </section>
          </div>
        </>
      )}
      {/* {loader && (
        <div className='loading-overlay'>
          <div className='bounce-loader'> */}
      {/* <div className='bounce1'></div>
								<div className='bounce2'></div>
								<div className='bounce3'></div> */}
      {/* <div className="loader"></div>
          </div>
        </div>
      )} */}
    </>
  );
};
export default ProductDetail;
